import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after purchasing?',
  a: 'You will receive immediate access to all 12 PDFs immediately after purchase — no waiting, no complicated steps. Everything downloads in minutes.'
}, {
  q: 'What level of riding instructor is this for?',
  a: 'Horse Riding Instructor Ready is designed for instructors who teach beginner and developing riders — children, teenagers and adults. It is suitable for private instructors, riding school instructors, pony club coaches and equestrian camp instructors regardless of where they are based.'
}, {
  q: 'Does this work for riding instructors in any country?',
  a: 'Yes. The material is written in clear, professional English and is designed to be adapted to your specific facility procedures, local standards and professional context. The teaching principles apply regardless of location.'
}, {
  q: 'Do I need to use all six volumes?',
  a: 'No. You can start with the volume that matches your current students and work forward from there. Many instructors start at Volume 2 or 3 and use the earlier volumes as reference. The system is designed to be flexible.'
}, {
  q: 'Can I use this for both private and group lessons?',
  a: 'Yes. Every volume includes guidance for both individual and group lesson formats. The Adaptation System bonus specifically covers mixed-level group management.'
}, {
  q: 'What currency will I pay in?',
  a: 'The price adapts automatically to your country at checkout. You pay in your local currency.'
}, {
  q: "What if it's not useful for me?",
  a: 'You are covered by a full 7-day money-back guarantee. If the material is not useful for your teaching situation, contact us within 7 days and we will refund 100% of your payment. No questions, no forms, no complications.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-ivory" data-id="element-93" data-mp="2kvwyag0evn3v">
      <div className="max-w-3xl mx-auto" data-id="element-94" data-mp="2kv51j1v2vjc0">
        <div className="text-center mb-16" data-id="element-95" data-mp="2ku3o4qqlakr4">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest" data-id="element-96" data-mp="2fxvfzxat7rtg">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-97" data-mp="2avwaagrlkitc">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="bg-white border border-gold-aged/40 rounded-xl overflow-hidden shadow-[0_2px_12px_rgba(18,53,36,0.05)]" data-id="element-98" data-mp="33ng0wlqiwz5d" data-mpi={index}>
                <button type="button" aria-expanded={isOpen} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-99" data-mp="2umhszscys7hi">
                  <span className="font-bold text-lg text-forest pr-8" data-id="element-100" data-mp="3uvr8fnrpjpb0">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-101" data-mp="7p756fan64xp" />
                </button>

                <AnimatePresence initial={false} data-id="element-102" data-mp="chrrkvr7xfr7">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-103" data-mp="hh4efgi3amts">
                      <div className="px-6 pb-5 text-ink border-t border-gold-aged/25 pt-4" data-id="element-104" data-mp="ve9kvhlptnpk">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}